import React, { useMemo, useState } from "react";
import "./RegularAdCard.css";
import HouseAdCard from "./HouseAdCard";
import useAdBannerAnalytics from "../../hooks/useAdBannerAnalytics";

const getCreativeKey = (ad) => {
  if (!ad) return "";

  return `${ad.campaignId || ""}:${ad.creativeId || ""}:${
    ad.creativeUrl || ""
  }`;
};

const RegularAdCard = ({
  ad = null,
  houseAd = null,
  mobileDividerEdge = "top",
  surface = "home",
  device = "desktop",
  analyticsSlot = "regular",
  viewabilityEnabled = true,
}) => {
  const creativeKey = useMemo(() => getCreativeKey(ad), [ad]);
  const [failedCreativeKey, setFailedCreativeKey] = useState("");

  const hasCommercialAd = Boolean(ad);
  const commercialAdIsRenderable =
    hasCommercialAd &&
    Boolean(creativeKey) &&
    failedCreativeKey !== creativeKey;
  const houseAdIsRenderable =
    !hasCommercialAd &&
    houseAd?.enabled === true &&
    houseAd?.regularEnabled === true;

  const {
    viewabilityRef,
    onClick: onBannerClick,
    onFailed: onBannerFailed,
  } = useAdBannerAnalytics({
    ad: hasCommercialAd ? ad : null,
    houseAd: houseAdIsRenderable ? houseAd : null,
    enabled: commercialAdIsRenderable || houseAdIsRenderable,
    surface,
    device,
    placement: "regular",
    slotKey: analyticsSlot,
    viewabilityEnabled,
  });

  if (!commercialAdIsRenderable && !houseAdIsRenderable) {
    return null;
  }

  const altText =
    ad?.altText || ad?.brandName || "تبلیغ در چه‌خبره";

  return (
    <div
      ref={viewabilityRef}
      className={`regular-ad-card-slot regular-ad-card-slot--divider-${
        mobileDividerEdge === "bottom" ? "bottom" : "top"
      }`}
    >
      {commercialAdIsRenderable ? (
        <a
          className="regular-ad-card"
          href={ad.targetUrl}
          target="_blank"
          rel="noopener noreferrer sponsored"
          onClick={onBannerClick}
          aria-label={`تبلیغ${ad.brandName ? ` ${ad.brandName}` : ""}`}
          data-ad-banner-type="commercial"
          data-ad-placement="regular"
          data-ad-campaign-id={String(ad.campaignId)}
          data-ad-creative-id={String(ad.creativeId)}
        >
          <img
            className="regular-ad-card__creative"
            src={ad.creativeUrl}
            alt={altText}
            loading="lazy"
            decoding="async"
            onError={() => {
              onBannerFailed();
              setFailedCreativeKey(creativeKey);
            }}
          />

          <span className="regular-ad-card__label" aria-hidden="true">
            تبلیغ
          </span>
        </a>
      ) : (
        <HouseAdCard
          houseAd={houseAd}
          placement="regular"
          onClick={onBannerClick}
        />
      )}
    </div>
  );
};

export default RegularAdCard;
